import React, { useState, useEffect } from 'react';
import './profileDetails.scss';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import avatar from "../../../assets/images/male_avatar.png";
import { FaInfoCircle } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai"
import ReactTooltip from 'react-tooltip';
import { FormattedMessage } from "react-intl";
import { buildResume } from "./../GetResume/getresume"
import * as html2pdf from 'html2pdf.js';
import * as commonService from "utils/CommonService";
import { useQuery } from "utils/CommonService";
import * as userActions from "redux/actions/UserActions";
import * as JobActions from "redux/actions/JobActions";
import storage from "utils/storage";
import { useIntl } from "react-intl";
import { Info } from "components/jobseeker/infomodal/Info";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CommonModal from "components/shared/ui-components/common-modal";
import { roles, common } from "config/app.constant";
import { moveToTop } from "utils/CommonService";
export function ProfileDetails(props) {
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.userReducer);
    const { interviewList } = useSelector((state) => state.jobReducer);
    const [jobCount, setJobCount] = useState({});
    const [userCount, setUserCount] = useState({
        applied: 0,
        rejected: 0,
        selected: 0,
        hired: 0,
        shortlisted: 0
      });
    const userId = storage.get("humlog_user");
    const translate = useIntl();
    const defaultForm = () => <div></div>;
    const [state, setState] = useState({ open: false });
    const [form, setForm] = useState({ defaultForm });
    const [profilePercentage, setProfilePercentage] = useState(0);
    const query = useQuery();
    let jobId = query.get("id");
    const BorderLinearProgress = withStyles((theme) => ({
        root: {
            height: 10,
            borderRadius: 5,
        },
        colorPrimary: {
            backgroundColor:
                theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
        },
        bar: {
            borderRadius: 5,
            background: `linear-gradient(
            90deg,
            rgba(11, 159, 225, 1) 100%,
            rgba(6, 120, 193, 1) 100%
          )`
        },
    }))(LinearProgress);

    useEffect(() => {
        setDataProgress();
    }, [userDetails]);

    useEffect(() => {
        fetchUserDetails();
        fetchUserList(props.jobId);
    }, [dispatch]);
    /**
     * Method for fetching user details
     */
    const fetchUserDetails = async () => {
        try {
            const response = await dispatch(userActions.getUserData(storage.get('humlog_user')));
            dispatch(JobActions.getInterviewByUserId(userId));
            if (response.value.success) {
                const jobCounts = updateJobCounts(response.value.data.jobs);
                setJobCount(jobCounts);
            }
        } catch (err) {
            console.log("error in fetching user details", err);
        }
    }
    /**
   * fetch user list by job Id
   */
    const fetchUserList = async (jobId) => {
        try {
            const response = await dispatch(JobActions.getUserListByJobId(jobId));
            if (response && response.value.success) {
                const jobCounts = updateUserCounts(response.value.data);
                setUserCount(jobCounts);
            }
        } catch (err) {
            console.log("error in fetching user details", err);
        }
    }
    /**
   * Set counts of users performed actions on a job
   * @param {Array} users list of users 
   * @returns count of different users [applied,rejected, hired, shortlisted]
   */
    const updateUserCounts = (users) => {
        let userCounts = {
            applied: 0,
            rejected: 0,
            selected: 0,
            hired: 0,
            shortlisted: 0
        };
        for (let user of users) {
            switch (user.jobs[0].status) {
                case 'Applied':
                    userCounts.applied = userCounts.applied + 1
                    break;
                case 'Shortlisted':
                    userCounts.shortlisted = userCounts.shortlisted + 1
                    break;
                case 'Selected':
                    userCounts.selected = userCounts.selected + 1
                    break;
                case 'Hired':
                    userCounts.hired = userCounts.hired + 1
                    break;
                case 'Rejected':
                    userCounts.rejected = userCounts.rejected + 1
                    break;
                default:
                    continue
            }
        }
        return userCounts
    }
    /**
     * Method for counting jobs of different status
     * @param {Array} jobs list of jobs of a job seeker
     * @returns counts of different job status
     */
    const updateJobCounts = (jobs) => {
        let jobCounts = {
            applied: 0,
            saved: 0,
            selected: 0,
            shortlisted: 0,
            rejected: 0
        };
        for (let job of jobs) {
            if (job.job_status == 0) {
                switch (job.status) {
                    case 'Applied':
                        jobCounts.applied = jobCounts.applied + 1
                        break;
                    case 'Saved':
                        jobCounts.saved = jobCounts.saved + 1
                        break;
                    case 'Selected':
                        jobCounts.selected = jobCounts.selected + 1
                        break;
                    case 'Shortlisted':
                        jobCounts.shortlisted = jobCounts.shortlisted + 1
                        break;
                    case 'Rejected':
                        jobCounts.rejected = jobCounts.rejected + 1
                        break;
                    default:
                        continue;
                }
            }
        }
        return jobCounts;
    }
    const history = useHistory();

    const handleModal = (component) => {
        setState({ open: true });
        setForm(component);
    };

    const handleClose = () => {
        setState({ open: false });
    };
    /**
   * method to set profile Progress
   */
    const setDataProgress = () => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            let profileTracker = 0;
            let skills = [];
            if (userDetails.job_intrested && userDetails.job_intrested.length) {
                for (let val of userDetails.job_intrested) {
                    for (let skill of val.skills) {
                        skills.push(skill);
                    }
                }
            }
            profileTracker = userDetails.about_me?.length > 0 ? profileTracker + 10 : profileTracker + 0;
            profileTracker = userDetails.contact?.length > 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.language_known?.length > 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.experience >= 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.name?.length > 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.dob?.length > 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.speak_english?.length > 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.address_current?.length > 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.profile_pic?.length > 0 ? profileTracker + 10 : profileTracker + 0;
            profileTracker = userDetails.job_intrested?.length > 0 ? profileTracker + 10 : profileTracker + 0;
            profileTracker = skills?.length > 0 ? profileTracker + 10 : profileTracker + 0;
            profileTracker = userDetails.gender >= 0 ? profileTracker + 5 : profileTracker + 0;
            profileTracker = userDetails.qualification?.length > 0 ? profileTracker + 10 : profileTracker + 0;
            profileTracker = userDetails.technical_cert?.length > 0 ? profileTracker + 10 : profileTracker + 0;

            setProfilePercentage(profileTracker);
        }
    };
    /**************** method to download resume as pdf *******************/
    const getresume = async () => {
        const RESUME_HTML = await buildResume(); //fetch resume html as string
        commonService.isLoading.onNext(true); // spinner starts
        const opt = {
            margin: [0, 0, 0, 0],
            filename: `${userDetails.name}_humlogjobs_resume.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, dpi: 72, letterRendering: true, width: 800, height: 1123 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', }
        };
        // convert html to pdf and download
        html2pdf().set(opt).from(RESUME_HTML, "string").save().then(() => {
            commonService.isLoading.onNext(false); // spinner stops
            downloadedResumeCounts() // Storing downloaded resume Counts
        });
    }
    // Skills Placeholder
    function availableSkills(jobIntrested) {
        let result = false;
        if (jobIntrested.length > 0) {
            for (let val of jobIntrested) {
                if (val.skills.length) {
                    result = true;
                    break
                }
            }
        }
        return result;
    }
    // Use to active job categories based on index selection for Employer
    const activeTab = (index) => {
        props.setTabIndex(index);
        moveToTop();
    }
    // Use to active job categories based on params selection for Jobseeker
    const activeJobSeekerTab = (param) => {
        (history.push('/dashboard', {params: param}));
        moveToTop();
    }
    // Storing Total Downloaded resume Counts
    const downloadedResumeCounts = () => {
        let formData = {
            total_downloaded_resume: true,
            _id: localStorage.getItem("humlog_user"),
        };
        dispatch(userActions.updateUserData(formData))
            .then((res) => {
                if (res.value.success) {
                    dispatch(userActions.getUserData(userId));
                    console.log(res.value.message);
                }
            })
            .catch((err) => console.log(err));
    };
    return (
        <>
            <CommonModal open={state.open} handelClose={handleClose}>
                {form}
            </CommonModal>
            {/* Profile Card */}
            <div className='profile-card mt-5 mb-2 ml-md-4 ml-2 py-3 shadow'>
                {
                    userDetails.profile_pic &&
                        userDetails.profile_pic.length > 0 ? (
                        <img src={`${userDetails.profile_pic}?${Date.now()}`} className='profile-image' onError={(e) => {
                            e.target.onError = null;
                            e.target.src = avatar;
                        }} alt="Profile Picture" />
                    ) : (
                        <img src={avatar} className='profile-image' alt="Profile Picture" />
                    )
                }
                <h3 className='h3'>
                    {
                        userDetails && userDetails.name && userDetails.name.length > 0
                            ?
                            (userDetails.name)
                            :
                            ("")
                    }
                </h3>
                <p className='user-details'>
                    {
                        userDetails &&
                            userDetails.contact &&
                            userDetails.contact.length > 0
                            ?
                            userDetails.contact
                            :
                            ("")
                    } | {
                        userDetails &&
                            (userDetails.role === roles.JOBSEEKER) ?
                            (userDetails.address_home &&
                                userDetails.address_home.length > 0
                                ?
                                userDetails.address_home
                                :
                                (""))
                            :
                            ((userDetails.role === roles.EMPLOYER) ?
                                (userDetails.email
                                    ?
                                    userDetails.email
                                    :
                                    ("")) : '')
                    }
                </p>
                <p className='user-details'>
                    {
                        userDetails &&
                            userDetails.about_me &&
                            userDetails.about_me.length > 0
                            ? (userDetails.about_me.map((data, index) => {
                                return (
                                    <span>
                                        <FormattedMessage id={(data.label)} />
                                        {index < userDetails.about_me.length - 1 ? ", " : ""}
                                    </span>
                                )
                            }))
                            : ""}
                </p>
                <div className='text-left'>
                    {
                        (userDetails && userDetails.role === roles.JOBSEEKER) ?
                            <h5 className='h6 mt-3 mb-1'>Skills</h5> : ''
                    }
                    {userDetails &&
                        (userDetails.role === roles.JOBSEEKER) &&
                        userDetails.job_intrested &&
                        userDetails.job_intrested.length > 0 ? (
                        availableSkills(userDetails.job_intrested) ? (
                            userDetails.job_intrested.map((val) => {
                                return (
                                    <>
                                        <div className="">
                                            {val.skills.map((skill) => {
                                                return (
                                                    <>
                                                        <div
                                                            className="user_btna mr-2"
                                                            style={{ display: "inline-block" }}
                                                        >
                                                            {skill}
                                                        </div>
                                                    </>
                                                );
                                            })}
                                        </div>
                                    </>
                                );
                            })
                        ) : (
                            <p className="field_placeholder">
                                <FormattedMessage
                                    id="submitSkills"
                                    defaultMessage="Please select your Skills"
                                />
                            </p>
                        )
                    ) : (
                        ''
                    )}
                    {
                        (userDetails && userDetails.role === roles.JOBSEEKER) ?
                            <h5 className='h6 mt-3 mb-1'>Interested In</h5> : ''
                    }
                    {userDetails &&
                        (userDetails.role === roles.JOBSEEKER) &&
                        userDetails.job_intrested &&
                        userDetails.job_intrested.length > 0 &&
                        userDetails.job_intrested.map((val) => {
                            return (
                                <>
                                    <div className="user_btna mr-2" style={{ display: "inline-block" }}>{val.job_category}</div>
                                </>
                            );
                        })}
                    {
                        (userDetails && userDetails.role === roles.JOBSEEKER) ?
                            <>
                                <h6 className="text-left mt-3 mb-2">
                                    {Math.round(profilePercentage)}%{" "}
                                    <FormattedMessage id="profileCompleted" defaultMessage="Profile completed" />
                                </h6>
                                <BorderLinearProgress variant="determinate" value={profilePercentage} />
                            </> : ''
                    }
                </div>
                {
                    (userDetails && userDetails.role === roles.EMPLOYER) ?
                        <div className='text-left'>
                            <h5 className='h6 mt-3 mb-1'><FormattedMessage id="hiringfor"/></h5>
                            {userDetails.organization_type ?
                                <div
                                    className="user_btna mr-2"
                                    style={{ display: "inline-block" }}
                                >
                                    {userDetails.organization_type} </div> : <br />}
                            
                            <h5 className='h6 mt-3 mb-1'><FormattedMessage id="companyName"/></h5>
                            {userDetails.company_name ?
                                <div
                                    className="user_btna mr-2"
                                    style={{ display: "inline-block" }}
                                >
                                    {userDetails.company_name} </div> : <br />}
                            
                            <h5 className='h6 mt-3 mb-1'><FormattedMessage id="companyEmail"/></h5>
                            <div
                                className="user_btna mr-2"
                                style={{ display: "inline-block" }}
                            >
                                {userDetails.email ? userDetails.email : ''}
                            </div>
                        </div> : ''
                }
                <hr />
                {
                    (userDetails && userDetails.role === roles.EMPLOYER) ?
                        <>
                            <button type='button' className='post-job py-2' onClick={() => history.push('/jobs')}>
							    <FormattedMessage id="jobPost"/>
                                <AiOutlinePlus className='add-icon' />
                            </button>
                        </> : ''
                }
                {
                    (userDetails && userDetails.role === roles.JOBSEEKER) ?
                        <div className="getreume_mainbox">
                            <div className="getreume_box">
                                <button
                                    type="button"
                                    className="resume_btn"
                                    onClick={getresume}
                                    disabled={profilePercentage && profilePercentage === 100 ? false : true}>
                                    <FormattedMessage id="getResume" />
                                </button>
                                <FaInfoCircle
                                    className="info_icon"
                                    data-tip={translate.formatMessage({ id: "getInfo" })}
                                    onClick={() =>
                                        handleModal(
                                            <Info handleClose={handleClose} />
                                        )}
                                />
                            </div>
                        </div>
                        :
                        ''
                }
                <ReactTooltip globalEventOff='click' />
            </div>
            {/* Job status Card */}
            {
                (userDetails && userDetails.role === roles.JOBSEEKER) ?
                    <div className='job-status-card mb-5 mt-2 ml-md-4 ml-2 shadow'>
                        <p className={ jobCount.applied > 0 ? 'job-category-btn' : ''} onClick={() =>( jobCount.applied > 0 ? activeJobSeekerTab('Applied') : '')}><FormattedMessage id='applied'/> <span>{jobCount.applied}</span></p>
                        <p className={ jobCount.saved > 0 ? 'job-category-btn' : ''} onClick={() => (jobCount.saved > 0 ? activeJobSeekerTab('Saved'): '')}><FormattedMessage id='saved'/> <span>{jobCount.saved}</span></p>
                        <p className={ (interviewList && interviewList.length > 0) ? 'job-category-btn' : ''} onClick={() => (!(interviewList && interviewList.length > 0) ? activeJobSeekerTab('Interview') : '')}><FormattedMessage id='interview' defaultMessage={'Interview'}/> <span>{interviewList && interviewList.length ? interviewList.length : 0}</span></p>
                        <p className={ jobCount.shortlisted > 0 ? 'job-category-btn' : ''} onClick={() => (jobCount.shortlisted > 0 ? activeJobSeekerTab('Shortlisted') : '')}><FormattedMessage id='shortlisted'/> <span>{jobCount.shortlisted}</span></p>
                        <p className={ jobCount.rejected > 0 ? 'job-category-btn' : ''} onClick={() => (jobCount.rejected > 0 ? activeJobSeekerTab('Not Shortlisted') : '')}><FormattedMessage id='notShortlisted'/> <span>{jobCount.rejected}</span></p>
                    </div> : ''
            }
            {
                (userDetails && userDetails.role === roles.EMPLOYER && props.showEmployerDashboardCount) ?
                    <div className='job-status-card my-md-5 my-3 ml-md-4 ml-2 shadow'>
                        <p className={userCount.applied > 0 ? 'job-category-btn' : ''} onClick={() => userCount.applied > 0 ? activeTab(0) : ''}><FormattedMessage id='applied'/> <span>{userCount.applied}</span></p>
                        <p className={userCount.shortlisted > 0 ? 'job-category-btn' : ''} onClick={() => userCount.shortlisted > 0 ? activeTab(1) : ''}><FormattedMessage id='goodFit'/> <span>{userCount.shortlisted}</span></p>
                        <p className={userCount.selected > 0 ? 'job-category-btn' : ''} onClick={() => userCount.selected > 0 ? activeTab(2) : ''}><FormattedMessage id='scheduleInterview'/> <span>{userCount.selected}</span></p>
                        <p className={userCount.hired > 0 ? 'job-category-btn' : ''} onClick={() => userCount.hired > 0 ? activeTab(3) : ''}><FormattedMessage id="hired" defaultMessage="Hired" /> <span>{userCount.hired}</span></p>
                        <p className={userCount.rejected > 0 ? 'job-category-btn' : ''} onClick={() => userCount.rejected > 0 ? activeTab(4) : ''}><FormattedMessage id='notFit'/> <span>{userCount.rejected}</span></p>
                        <p className='job-category-btn' onClick={() => activeTab(5)}><FormattedMessage id="viewMoreJobSeeker" defaultMessage={common.VIEW_MORE_JS} /></p>
                    </div> : ''
            }
        </>
    )
}